import { render } from "./experience.vue?vue&type=template&id=31671d46&scoped=true"
import script from "./experience.vue?vue&type=script&lang=js"
export * from "./experience.vue?vue&type=script&lang=js"

import "./experience.vue?vue&type=style&index=0&id=31671d46&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31671d46"]])

export default __exports__